// @fileoverview : 경남-KPI > 제조리드타임(P)

import { customFunctions } from "@/config/customFunction";
import { KPIActionHeader } from "@/features/kpi/actionHeader";
import { useKPIData } from "@/features/kpi/hook/useKPIData";
import { Header } from "@/features/standard/Header";
import { HeaderSubTitle } from "@/features/standard/SubTitle";
import { HeaderTitle } from "@/features/standard/Title";
import { GridTable } from "@/features/ui/PMS/gridTable";
import CustomTable from "@/features/ui/table/CustomTable";
import useColumnList from "@/hooks/useColumnList";
import { KPIPageProps } from "@/pages/KPI/type";
import { DatetimeUtilMinute } from "@/utils/dateTimeUtil";
import timeUtil from "@/utils/timeUtil";
import { Flex } from "@mantine/core";
import { useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const KPILeadTime = Object.assign(
  {},
  {
    Header: Header,
    HeaderTitle: HeaderTitle,
    HeaderSubTitle: HeaderSubTitle,
    KPIActionHeader: KPIActionHeader,
    CustomTable: CustomTable,
  },
);

export const Audit = customFunctions.ADD_KPI_AUDIT_DATA;
export const KPILeadtimePage = ({ mode }: KPIPageProps) => {
  const queryClient = useQueryClient();
  const today = dayjs().subtract(1, "day").startOf("day").toDate();
  const oneWeekAgo = dayjs().subtract(7, "day").startOf("day").toDate();
  const { t } = useTranslation();
  const columnlist = useColumnList();

  const [content, setContent] = useState<any[]>([]);
  const [item, setItem] = useState<string | null>("");
  const [selectList, setSelectList] = useState<Set<number>>(new Set());
  const [stateDate, setStateDate] = useState<[Date | null, Date | null]>([oneWeekAgo, today]);
  const [averageLeadTime, setAverageLeadTime] = useState<string>("");

  const { itemData, leadTimeData, auditKPIData } = useKPIData({
    mode,
    value: item,
    stateDate,
    options: Audit ? { fetchAuditKPI: true } : { fetchLeadTime: true },
  });

  useEffect(() => {
    const transform = (data: any[]) =>
      data.map((d) => ({
        productionPlanId: d.productionPlanId,
        scheduledAt: timeUtil(d.scheduledAt ?? ""),
        itemCode: d.itemCode,
        itemSpec: d.itemSpec,
        workerName: d.workerName,
        workEndTime: DatetimeUtilMinute(d.workEndTime ?? ""),
        workStartTime: DatetimeUtilMinute(d.workStartTime ?? ""),
        leadTime: d.leadTime,
      }));

    const calculateAverage = (data: any[]) => {
      if (!Array.isArray(data) || data.length === 0) return "0.00";
      const total = data.reduce((sum, d) => sum + parseFloat(d.leadTime), 0);
      return (total / data.length).toFixed(2);
    };

    if (Array.isArray(leadTimeData?.data)) {
      const transformed = transform(leadTimeData?.data ?? []);
      setContent(transformed);
      setAverageLeadTime(calculateAverage(leadTimeData?.data ?? []));
    } else if (Array.isArray(auditKPIData?.data?.rows ?? [])) {
      const rows = auditKPIData?.data.rows;
      const transformed = transform(rows ?? []);
      setContent(transformed);
      setAverageLeadTime(calculateAverage(rows ?? []));
    } else {
      setContent([]);
      setAverageLeadTime("0.00");
    }
  }, [leadTimeData, auditKPIData]);

  const TableHeader = {
    machine: [t("item.code"), t("item.name"), t("item.spec"), t("kpi.leadtime.averageTime")],
  };

  const BodyData = {
    machine: [
      {
        [t("item.code")]: itemData?.code ?? "-",
        [t("item.name")]: itemData?.name,
        [t("item.spec")]: itemData?.spec ?? "-",
        [t("kpi.leadtime.averageTime")]: averageLeadTime === "NaN" ? "-" : averageLeadTime,
      },
    ],
  };
  useEffect(() => {
    return () => {
      queryClient.removeQueries({ queryKey: ["kpi"] });
    };
  }, []);

  return (
    <Flex gap="md" direction={"column"} p="sm">
      <KPILeadTime.Header>
        <KPILeadTime.HeaderTitle>{t("kpi.leadtime.leadtime")}(P)</KPILeadTime.HeaderTitle>
        <KPILeadTime.HeaderSubTitle>{t("kpi.leadtime.subTitle")}</KPILeadTime.HeaderSubTitle>
      </KPILeadTime.Header>
      <KPILeadTime.KPIActionHeader
        setItem={setItem}
        stateDate={stateDate}
        setStateDate={setStateDate}
        mode={mode}
      />
      <KPILeadTime.CustomTable headers={TableHeader.machine} data={BodyData.machine} />
      <GridTable
        headerList={columnlist.leadTimeItemTable}
        row={content}
        setRow={setContent}
        selectList={selectList}
        //@ts-ignore
        setSelectList={setSelectList}
        width={"100%"}
        maxWidth={"100%"}
        height={750}
        resizable={true}
      />
    </Flex>
  );
};
